<template>
  <span>

    <span @click="showAddSection"><slot></slot></span>

    <b-modal v-model="modalAdd" size="lg" centered no-fade>
      <div slot="modal-header">{{$t('TEMPLATES.ADD.TITLE')}}</div>
      <div class="p-4 text-center" v-if="modalLoading">
        <img src="/img/loading.gif" />
        <h5 style="margin: 0; padding: 0;">{{$t('TEMPLATES.ADD.PROCESSING')}}</h5>
      </div>
      <div class="pl-4 pr-4" v-if="modalLoading === false">
        <form enctype="multipart/form-data">
          <div class="form-group row">
            <label class="col-form-label">{{ $t('TEMPLATES.ADD.INPUT_NAME') }}</label>
            <b-input autofocus v-on:keyup.enter="addDocument" v-model="addFormName" type="text" name="name" required></b-input>
          </div>

          <div class="form-group row">
            <label class="col-form-label">{{ $t('TEMPLATES.ADD.INPUT_VERSION') }}</label>
            <input class="form-control" v-on:keyup.enter="addDocument" v-model="addFormVersion" type="text" name="name" required />
          </div>

          <div class="form-group row">
            <label class="col-form-label">{{ $t('TEMPLATES.ADD.INPUT_DOCUMENT') }}</label>
            <b-form-file
              v-model="addFormDocument"
              :state="Boolean(addFormDocument)"
              :placeholder="placeHolder"
              accept=".xml"
            ></b-form-file>
          </div>

          <div class="form-group row">
            <b-form-group :label="$t('TEMPLATES.ADD.INPUT_PUBLISH')">
              <b-form-radio-group id="addFormPublish"  v-on:keyup.enter="addDocument" v-model="addFormPublish" name="publish">
                <b-form-radio value="0">{{ $t('NO')}}</b-form-radio>
                <b-form-radio value="1">{{ $t('YES')}}</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </div>

          <div class="form-group row">
            <b-form-group :label="$t('TEMPLATES.ADD.INPUT_PUBLIC')">
              <b-form-radio-group id="addFormPublic" v-model="addFormPublic"  v-on:keyup.enter="addDocument" name="public">
                <b-form-radio value="0">{{ $t('NO')}}</b-form-radio>
                <b-form-radio value="1">{{ $t('YES')}}</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </div>
        </form>
      </div>
      <div slot="modal-footer" class="w-100">
        <div v-if="modalLoading === false">
          <b-btn @click="hideAddSection">{{ $t('CLOSE')}}</b-btn>

          <b-button
            variant="primary"
            class="btn-fill"
            @click="addDocument"
          >{{ $t('TEMPLATES.ADD.ADD')}}</b-button>
        </div>
      </div>
    </b-modal>
  </span>
</template>
<script>
export default {
  data() {
    return {
      modalAdd: false,
      modalLoading: false,
      addFormName: "",
      addFormVersion: "1.0",
      addFormDocument: "",
      addFormPublish: 0,
      addFormPublic: 1,
      selected: 0,
      user: this.$store.getters["auth/user"]
    };
  },
  methods: {
    showAddSection() {
      this.modalAdd = true;
    },
    hideAddSection() {
      this.modalAdd = false;
      this.sectionName = "";
      this.modalLoading = false;
    },
    addDocument: function() {
      let self = this;
      let formData = new FormData();
      formData.append("Document", this.addFormDocument);
      formData.append("Name", this.addFormName);
      formData.append("Version", this.addFormVersion);
      formData.append("Publish", this.addFormPublish);
      formData.append("Public", this.addFormPublic);
      this.modalLoading = true;
      this.$http
        .post(process.env.VUE_APP_BACKEND + `/template/add`, formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(function() {
          self.hideAddSection();
          if (self.addFormPublish === 0) {
            self.selected = 2;
            self.$noty.info(self.$t("TEMPLATES.ADD.SUCCESS.CREATED_DRAFT"));
          } else {
            self.selected = 1;
            self.$noty.info(self.$t("TEMPLATES.ADD.SUCCESS.CREATED_PUBLISH"));
          }
        })
        .catch(function(error) {
          self.modalLoading = false;
          self.$noty.error(self.$t(error.response.data));
        });
    }
  },
  computed: {
    placeHolder() {
      return this.$t('TEMPLATES.ADD.SELECT_DOCUMENT');
    },
    documentName() {
      return (
        this.details.document.name + ":" + this.details.documentVersion.version
      );
    }
  }
};
</script>
<style>
</style>